export const invoiceDeliveryNOteDiscrepancy = {
  INDN_discrepancy_item_dn_notfound: `Delivery Note '{{2}}' not found in item '{{1}}'`,
  INDN_discrepancy_item_qty_mismatch: `Item '{{1}}' with quantity '{{2}}' doesn't match with quantity '{{4}}' of Delivery Note '{{3}}'`,
  indn_item_description_not_attached: `Item '{{1}}' description is not attached to Invoice '{{0}}'`,
  indn_item_referencecode_not_attached: `Item '{{1}}' reference code is not attached to Invoice '{{0}}'`,
  inpo_item_description_not_attached: `Item '{{0}}' description is not attached to Invoice '{{1}}'`,
  inpo_item_referencecode_not_attached: `Item '{{0}}' reference code is not attached to Invoice '{{1}}'`,
  podn_item_description_not_attached: `Item '{{1}}' description is not attached to Delivery Note '{{0}}'`,
  podn_item_referencecode_not_attached: `Item '{{1}}' reference code is not attached to Delivery Note '{{0}}'`,
  consumed: "Consumed",
  effective: "Effective",
};
